const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  REGISTER: '/register',
  FREE_PLAY: '/free-play',
  /** Results lobby (KenoGO) — entry pods for games/lotteries. */
  RESULTS: '/results',
  CASINO: {
    DISCOVERY: '/casino',
    GAME: (id: string | number) => `/casino/games/${id}/play`,
    GAMES: '/casino/games',
    GAME_INFO: (id: string | number) => `/casino/games/${id}`,
    BROWSE: '/casino/browse',
    FAVOURITES: '/casino/favourites',
    OFFERS: '/casino/offers',
    CATEGORY: (slug: string) => `/casino/${slug}`,
    NEW_GAMES: 'new-games',
    SLOTS: 'slot-games',
    JACKPOT_OVERDRIVE: 'jackpot-overdrive',
    JACKPOTS_GAMES: 'jackpots-games',
    TABLE_GAMES: 'tablegames',
    LIVE_DEALER: 'live-casino',
    SLINGO: 'slingo',
    CRASH_GAMES: 'crash-games',
    INSTANT_WIN: 'instantwin-games',
    MEGAWAYS: 'megaways',
    DROPS_AND_WINS: 'drops-and-wins-games',
    DEPOSIT_BONUS: '/casino-deposit-bonus',
  },
  KENOGO: {
    LIVE_DRAW: '/live',
    PLAY: '/play',
    JACKPOT: '/play/jackpot',
    CLASSIC: '/play/classic',
    HEAD_OR_TAILS: '/play/heads-or-tails',
    RESULTS: '/results/keno/results',
    MY_TICKETS: '/my-account/my-tickets',
  },
  LIVE_CASINO: {
    DISCOVERY: '/live-casino',
    BROWSE: '/live-casino/browse',
    FAVOURITES: '/live-casino/favourites',
    OFFERS: '/live-casino/offers',
    CATEGORY: (slug: string) => `/live-casino/${slug}`,
    QUICK_SEAT: '/live-casino/games/quickseat/play',
    GAME: (id: string | number) => `/live-casino/games/${id}/play`,
    GAME_INFO: (id: string | number) => `/live-casino/games/${id}`,
    LIVE_BLACKJACK: 'blackjack',
    LIVE_ROULETTE: 'roulette',
    GAME_SHOWS: 'game-shows',
    ASIAN_GAMES: 'asian-games',
    LIVE_LOTTERY: 'live-lottery',
    LIVE_SLOTS: 'live-slots',
  },
  LOTTO: {
    DISCOVERY: '/lotteries',
    PURCHASES: '/lotteries/purchases',
    BROWSE: '/lotteries/browse',
    OFFERS: '/lotteries/offers',
    LOTTERY: (lotteryPath: string) => `/lotteries${lotteryPath}`,
    LOTTERY_LEGACY: (lotteryPath: string) => `https://lottoland.co.uk${lotteryPath}`,
    // TODO: Replace with the new syndicate path when syndicates are released
    SYNDICATE: (syndicatePath: string) => `https://lottoland.co.uk${syndicatePath}`,
    RESULTS: {
      IRISHLOTTO: '/lotteries/irish-lottery/results-winning-numbers',
      POWERBALL: '/lotteries/powerball/results-winning-numbers',
      MEGAMILLIONS: '/lotteries/megamillions/results-winning-numbers',
      EUROMILLIONSPLUS: '/lotteries/millionaire/results-winning-numbers',
      EUROMILLIONSGO: '/lotteries/millionaire-go/results-winning-numbers',
      POLISHMINILOTTO: '/lotteries/minilotto/results-winning-numbers',
      EURODREAMS: '/lotteries/eurodreams/results-winning-numbers',
      EUROJACKPOT: '/lotteries/eurojackpot/results-winning-numbers',
      SUPERENALOTTO: '/lotteries/superenalotto/results-winning-numbers',
      LOTTO5: '/lotteries/lottox5/results-winning-numbers',
      THEDAILYMILLION: '/lotteries/the-daily-million/results-winning-numbers',
      LUCKYFORLIFE: '/lotteries/lucky-for-life/results-winning-numbers',
      KENO247: '/lotteries/keno247/results-winning-numbers',
    },
    DRAW_HISTORY: {
      IRISHLOTTO: '/lotteries/irish-lottery/results-winning-numbers/draw-history',
      POWERBALL: '/lotteries/powerball/results-winning-numbers/draw-history',
      MEGAMILLIONS: '/lotteries/megamillions/results-winning-numbers/draw-history',
      EUROMILLIONSPLUS: '/lotteries/millionaire/results-winning-numbers/draw-history',
      EUROMILLIONSGO: '/lotteries/millionaire-go/results-winning-numbers/draw-history',
      POLISHMINILOTTO: '/lotteries/minilotto/results-winning-numbers/draw-history',
      EURODREAMS: '/lotteries/eurodreams/results-winning-numbers/draw-history',
      EUROJACKPOT: '/lotteries/eurojackpot/results-winning-numbers/draw-history',
      SUPERENALOTTO: '/lotteries/superenalotto/results-winning-numbers/draw-history',
      LOTTO5: '/lotteries/lottox5/results-winning-numbers/draw-history',
      THEDAILYMILLION: '/lotteries/the-daily-million/results-winning-numbers/draw-history',
      LUCKYFORLIFE: '/lotteries/lucky-for-life/results-winning-numbers/draw-history',
      KENO247: '/lotteries/keno247/results-winning-numbers/draw-history',
    },
    CATEGORIES: {
      ALL: '/lotteries/all',
      MOST_POPULAR: '/lotteries/most-popular',
      TODAYS_DRAWS: '/lotteries/todays-draws',
      HUGE_JACKPOTS: '/lotteries/huge-jackpots',
      ONE_OR_LESS: '/lotteries/one-or-less',
      BEST_ODDS: '/lotteries/best-odds',
      QUICK_DRAWS: '/lotteries/quick-draws',
    },
  },
  SPORTS: {
    ROOT_SPORTSBOOK_PATHNAME: '/sportsbook',
    DISCOVERY: '/sportsbook?page=overview',
    IN_PLAY: '/sportsbook?page=live',
    MY_BETS: '/sportsbook?page=betHistory',
    FREE_BETS: '/sportsbook?page=settings',
    ALL_SPORTS: '/sportsbook?page=allSports',
    OFFERS: '/sportsbook/offers',
    HELP_GUIDE: '/sportbettingguide',
  },
  BINGO: {
    DISCOVERY: '/bingo',
    ROOMS: '/bingo/games/OmniBingo/play',
    OFFERS: '/bingo/offers',
    MINI_GAMES: '/mini-bingo-games',
    TERMS_AND_RULES: '/bingotermsandrules',
    FEATURES: '/bingo-features',
    CASINO_BINGO_PLAY: '/casino/bingo/play',
    GAME: (id: string | number) => `/bingo/games/${id}/play`,
  },
  SCRATCHCARDS: {
    DISCOVERY: '/scratchcards',
    BROWSE: '/scratchcards/browse',
    PURCHASES: '/scratchcards/purchases',
    OFFERS: '/scratchcards/offers',
    CATEGORIES: {
      ALL: '/scratchcards/all',
      POPULAR: '/scratchcards/popular',
      BUDGET: '/scratchcards/budget',
      MILLIONAIRE: '/scratchcards/millionaire',
      BEST_ODDS: '/scratchcards/best-odds',
      LOTTERY: '/scratchcards/lottery',
      SPECIAL: '/scratchcards/special',
      CHARITY: '/scratchcards/charity',
    },
    // TODO: Temporal change to legacy path to the new scratchcard path when scratchcards are released
    GAME: (id: string) => `/scratchcards/${id}`,
    GAME_INFO: (id: string | number) => `/scratchcards/cards/${id}`,
    // TODO: Replace with the new scratchcard routes when scratchcards are released
    SCRATCHCARD: (scratchcardPath: string) => `https://lottoland.co.uk${scratchcardPath}`,
  },
  MAGAZINE: {
    HOME: '/magazine',
    HOME_WITH_PAGE_NUMBER: '/magazine/page/:pageNumber',
    SEARCH: '/magazine/search',
    AUTHOR: '/magazine/author/:authorSlug',
    AUTHOR_WITH_PAGE_NUMBER: '/magazine/author/:authorSlug/page/:pageNumber',
    CATEGORY: '/magazine/:categorySlug',
    CATEGORY_WITH_PAGE_NUMBER: '/magazine/:categorySlug/page/:pageNumber',
    ARTICLE: '/magazine/:articleSlug.html',
  },
  OFFERS: '/promotions',
  OFFERS_BONUSES: '/promotions?tab=bonuses',
  /** Where "Browse" CTAs of vertical-wide bonuses take the player. Markets without those lobbies override it. */
  PRODUCT_BROWSE: {
    GAMES: '/casino',
    LOTTERIES: '/lotteries',
    SPORTSBOOK: '/sportsbook?page=overview',
  },
  BETCLUB: 'https://www.lottoland.co.uk/betclub',
  SYNDICATES: '/syndicates',
  OFFER_BUNDLE: (bundleCode: string, iterationNr?: number) => `/ob?code=${bundleCode}${iterationNr != null ? `&iterationNr=${iterationNr}` : ''}`,
  MULTIPLIER_TABLE: '/multipliertable',
  CHECKOUT: {
    THANK_YOU: '/thank-you',
  },
  HELP_CENTRE: {
    BASE_URL: 'https://beta-help.lottoland.co.uk/',
    CONTACT_US: 'https://beta-help.lottoland.co.uk/',
    CHAT: 'https://beta-help.lottoland.co.uk/embed/lopetto/',
  },
  FOOTER: {
    DOWNLOAD_THE_APP: {
      APP_STORE: 'https://apps.apple.com/gb/app/lottoland-uk-casino-lottery/id1474057957',
      GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=co.uk.lottoland.app',
    },
    ACHIEVEMENTS: {
      THE_CLIMATE_PLEDGE: 'https://www.theclimatepledge.com/content/amazonclimatepledge/us/en/Signatories/lottoland.html#main-navigation',
    },
    LEGAL: {
      GAMBLE_SAFELY: '/gamble-safely',
      GAMBLE_AWARE: 'http://www.gambleaware.co.uk/',
      GAMBLING_COMMISSION: 'https://www.gamblingcommission.gov.uk/',
      GAMBLING_COMMISSION_ACCOUNT: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/38991',
      GAMBLERS_ANONYMOUS: 'https://gamblersanonymous.org.uk/',
      GAMSTOP: 'https://www.gamstop.co.uk/',
      GAMCARE: 'https://www.gamcare.org.uk/get-support/talk-to-us-now/',
      GAMCARE_ORG: 'http://www.gamcare.org.uk',
      TAKE_TIME_TO_THINK: 'https://www.taketimetothink.co.uk/',
      IBAS: 'https://ibas-uk.com/',
      GIBRALTAR: 'https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling',
      BETTING_REGULATION: 'https://www.bettingregulations.com/companies/eu-lotto-ltd',
      BEGAMBLEAWARE: 'https://www.begambleaware.org',
      CUST_HELP: 'https://lottolanduk.custhelp.com',
      GIBRALTAR_REMOTE_GAMBLING: 'https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling',
      FATF_GAFI: 'http://www.fatf-gafi.org',
      SANCTIONS_LIST: 'https://www.gov.uk/government/publications/financial-sanctions-consolidated-list-of-targets/consolidated-list-of-targets',
      TERMS: '/terms',
      DOCUMENTS: 'https://www.lottoland.co.uk/documentsneeded',
      SET_DEPOSIT_LIMIT: '/my-account/safer-gambling',
    },
    SOCIALS: {
      INSTAGRAM: 'https://www.instagram.com/lottolanduk/',
      FACEBOOK: 'https://www.facebook.com/lottoland.co.uk/',
    },
    NAVIGATION: {
      LOTTERY: {
        RESULTS: 'https://www.lottoland.co.uk/lottery-results',
        SYNDICATES: 'https://www.lottoland.co.uk/syndicates-overview',
        MAGAZINE: 'https://www.lottoland.co.uk/magazine',
        APPS: 'https://www.lottoland.co.uk/apps',
      },
      INFORMATION: {
        PAYOUT: '/payouts',
        PRIVACY: '/privacy',
        TERMS: '/terms',
        TERMS_SUMMARY: '/terms-summary',
        CORPORATE: 'https://www.lottolandcorporate.com/',
        COOKIE_POLICY: '/cookiepolicy',
        GAME_FAIRNESS: '/gamefairness',
        LOTTO_BETTING: '/lotto-betting',
        COMPLAINTS_PROCEDURE: '/complaints-procedure',
        ACCESSIBILITY_STATEMENT: '/accessibilitystatement',
      },
      CONTACT: {
        ABOUT_US: 'https://www.lottolandcorporate.com/',
        CAREER: 'https://www.lottolandcorporate.com/careers/',
        AFFILIATE_PROGRAM: 'http://www.lottolandaffiliates.com/?lang=en',
        B2B: 'https://lottolandsolutions.com/',
      },
      GAMBLE_SAFELY: {
        GAMBLE_SAFELY: '/gamble-safely',
        SUPPORT_NETWORKS: '/support-networks',
        DOCUMENTS: '/documentsneeded',
        UNDERAGE_PROTECTION: '/underage-protection',
        AFFORDABILITY_CHECKS: '/affordabilitychecks',
        SET_DEPOSIT_LIMIT: '/my-account/safer-gambling',
      },
    },
  },
  MY_ACCOUNT: {
    ROOT: '/my-account',
    PROFILE: '/my-account/profile',
    WALLET: '/my-account/wallet',
    WITHDRAW: '/my-account/withdraw',
    LOCKED_FUNDS: '/my-account/locked-funds',
    TRANSACTIONS: '/my-account/transactions',
    PAYMENT_METHODS: '/my-account/payment-methods',
    LIFETIME_NET_DEPOSITS: '/my-account/lifetime-net-deposits',
    INBOX: '/my-account/inbox',
    INBOX_MESSAGE: (id: string) => `/my-account/inbox/${id}`,
    HISTORY: '/my-account',
    GAME_HISTORY: '/my-account/history/mygames',
    UPLOAD_DOCUMENTS: 'https://lottolanduk.custhelp.com/app/documents',
    DEPOSIT: (returnUrl?: string) => `/my-account/wallet${returnUrl ? `?returnpage=${returnUrl}` : ''}`,
    SETTINGS: (action?: 'verify-phone' | 'verify-email') => `/my-account/settings${action ? `?action=${action}` : ''}`,
    MY_TICKETS: '/my-account/my-tickets',
    SAFER_GAMBLING: '/my-account/safer-gambling',
  },
  TIME_OFF: '/time-off',
  ASK: '/ask',
  SPORTS_BETTING_GUIDE: 'https://www.lottoland.co.uk/sportbettingguide',
  UNSUBSCRIBE: '/unsubscribe',
  REGISTER_REDIRECTION: '/account/profile',
  REGISTER_REDIRECTION_SUCCESS: '/account/profile?registration-success=true',
  FALLBACK_URL: 'https://lottoland.co.uk',
  LEGACY_PURCHASE: {
    DESKTOP: '/account/history',
    MOBILE: '/account/history/tickets',
  },
} as const;

/** Lotteries migrated to Chroma. Move here when migrating from legacy. */
const CHROMA_LOTTERIES = {
  IRISHLOTTO: '/lotteries/irish-lottery',
  POWERBALL: '/lotteries/powerball',
  MEGAMILLIONS: '/lotteries/megamillions',
  EUROMILLIONSPLUS: '/lotteries/millionaire',
  EUROMILLIONSGO: '/lotteries/millionaire-go',
  POLISHMINILOTTO: '/lotteries/minilotto',
  EURODREAMS: '/lotteries/eurodreams',
  EUROJACKPOT: '/lotteries/eurojackpot',
  SUPERENALOTTO: '/lotteries/superenalotto',
  LOTTO5: '/lotteries/lottox5',
  THEDAILYMILLION: '/lotteries/the-daily-million',
  LUCKYFORLIFE: '/lotteries/lucky-for-life',
} as const;

/** Lotteries not yet migrated to Chroma. Move to CHROMA_LOTTERIES when a lottery is migrated. */
const LEGACY_LOTTERIES = {
  FRENCHLOTTO: '/lotteries/winwin-charity-lotto',
  UKLOTTO: '/lotteries/lotto-plus',
  POLISHLOTTO: '/lotteries/polish-lottery',
  AUSTRIALOTTO: '/lotteries/austrian-lottery',
  GERMANKENO: '/lotteries/keno',
  MARKSIX: '/lotteries/marksix',
  WORLDMILLIONS: '/lotteries/worldmillions',
  ELGORDOPRIMITIVA: '/lotteries/sundaylotto',
  KENOW: '/lotteries/kenow',
  KENO247: '/lotteries/keno247',
  SUMMERGORDO: '/lotteries/summer-lottery',
  SOUTHAFRICANPOWERBALL: '/lotteries/smallfortune',
  SOUTHAFRICANLOTTO: '/lotteries/south-african-lotto',
  MEGASENA: '/lotteries/megasena',
  QUINA: '/lotteries/quina',
  ELGORDO: '/lotteries/christmas-lottery',
  NEWYEARSLOTTERY: '/lotteries/mega',
  ELNINO: '/lotteries/elnino',
} as const;

const ALL_ROUTES = {
  ...ROUTES,
  LOTTO: {
    ...ROUTES.LOTTO,
    MIGRATED: CHROMA_LOTTERIES,
    LEGACY_ONLY: LEGACY_LOTTERIES,
    LOTTERIES: { ...CHROMA_LOTTERIES, ...LEGACY_LOTTERIES },
  },
} as const;

export { ALL_ROUTES as ROUTES };
